import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { UpdateBranchPayload, useUpdateBranch } from "hooks/useBranches";
import { BaseButton } from "Components";

const EditBranchModal = ({ isOpen, toggle, editDetails }) => {
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const { mutate: updateBranch, isPending } = useUpdateBranch();

  useEffect(() => {
    if (editDetails) {
      setName(editDetails.name);
      setAddress(editDetails.address);
    }
  }, [editDetails]);

  const handleSubmit = () => {
    const payload: UpdateBranchPayload = {
      id: editDetails.id,
      data: {
        ...editDetails,
        name,
        address,
      },
    };
    updateBranch(payload, {
      onSuccess: () => {
        toggle(); // Close modal after successful update
      },
    });
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Edit Branch</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label for="branchName">Branch Name</Label>
          <Input
            id="branchName"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter branch name"
            required
          />
        </FormGroup>
        <FormGroup>
          <Label for="branchAddress">Branch Address</Label>
          <Input
            id="branchAddress"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            placeholder="Enter branch address"
            required
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <BaseButton
          color="primary"
          onClick={handleSubmit}
          loading={isPending}
          disabled={isPending}
        >
          Update Branch
        </BaseButton>
        <BaseButton color="secondary" onClick={toggle}>
          Cancel
        </BaseButton>
      </ModalFooter>
    </Modal>
  );
};

export default EditBranchModal;
